<h2 mat-dialog-title>{{ data.presetParentTask ? 'Add Subtask' : 'Create Task' }}</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <section class="summary-card">
    <div>
      <p class="eyebrow">Task Intake</p>
      <h3>{{ data.presetParentTask ? 'Attach work under an existing parent task' : 'Route work into a project or keep it standalone' }}</h3>
    </div>
    <span class="scope-pill" [class.standalone]="form.value.isStandalone">{{ form.value.isStandalone ? 'Standalone' : 'Project linked' }}</span>
  </section>

  <section class="form-card">
    <div class="form-grid">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Task Title</mat-label>
        <input matInput formControlName="title">
        <mat-error *ngIf="form.get('title')?.hasError('required')">Task title is required.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput rows="4" formControlName="description"></textarea>
      </mat-form-field>

      <mat-checkbox formControlName="isStandalone" (change)="onStandaloneChange()" [disabled]="!!data.presetParentTask">
        Create as standalone task
      </mat-checkbox>

      <div class="helper-copy" *ngIf="data.presetParentTask">
        Parent task: <strong>{{ data.presetParentTask.title }}</strong>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Project</mat-label>
        <mat-select formControlName="projectId" (selectionChange)="onProjectChange()" [disabled]="form.value.isStandalone || !!data.presetParentTask">
          <mat-option [value]="null">Select project</mat-option>
          <mat-option *ngFor="let project of data.projects" [value]="project.id">{{ project.name }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="form.value.isStandalone">Standalone tasks do not belong to a project.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Parent Task</mat-label>
        <mat-select formControlName="parentTaskId" [disabled]="!!data.presetParentTask">
          <mat-option [value]="null">No parent task</mat-option>
          <mat-option *ngFor="let task of filteredParentTasks" [value]="task.id">{{ task.title }}</mat-option>
        </mat-select>
        <mat-hint>Choose a parent to create a subtask.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option *ngFor="let option of priorityOptions" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Assigned Staff</mat-label>
        <mat-select formControlName="assignedStaffId" [disabled]="!data.canAssignAnyStaff">
          <mat-option [value]="null">Unassigned</mat-option>
          <mat-option *ngFor="let staff of data.staffs" [value]="staff.id">{{ staff.fullName }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="!data.canAssignAnyStaff">This task will be assigned to you.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Due Date</mat-label>
        <input matInput type="date" formControlName="dueDate">
      </mat-form-field>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">
    {{ data.presetParentTask ? 'Add Subtask' : 'Create Task' }}
  </button>
</mat-dialog-actions>
